<template>
  <nav class="bg-white shadow-lg fixed w-full top-0 z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <a href="/">
              <img src="/assets/logo.png" alt="AMGO" class="h-16" />
            </a>
          </div>
        </div>
        <div class="hidden md:block">
          <div class="ml-10 flex items-baseline space-x-4">
            <div v-for="(section, index) in sections" :key="index">
              <a
                v-if="section.id != 'actualites'"
                :href="'/#' + section.id"
                :class="`nav-link ${
                  activeSection === section.id
                    ? 'text-indigo-600'
                    : 'text-gray-700'
                } hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors`"
              >
                {{ section.name }}</a
              >
            </div>

            <a
              @click="openAdhesion"
              href="/#adhesiont"
              class="nav-link block bg-indigo-600 text-white px-3 py-2 rounded-md text-base font-medium hover:bg-indigo-700"
              >Adhérer</a
            >
          </div>
        </div>
        <div class="md:hidden">
          <button
            id="mobile-menu-btn"
            class="text-gray-700 hover:text-indigo-600 focus:outline-none"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div id="mobile-menu" class="md:hidden hidden bg-white border-t">
      <div class="px-2 pt-2 pb-3 space-y-1">
        <div v-for="(section, index) in sections" :key="index">
          <a
            v-if="section.id != 'actualites'"
            :href="'/#' + section.id"
            class="block text-gray-700 hover:text-indigo-600 px-3 py-2 rounded-md text-base font-medium"
          >
            {{ section.name }}</a
          >
        </div>
        <a
          href="/#adhesiont"
          @click="openAdhesion"
          class="nav-link block bg-indigo-600 text-white px-3 py-2 rounded-md text-base font-medium hover:bg-indigo-700"
          >Adhérer</a
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Header",
  props: {},
  data() {
    return {
      activeSection: null,
      sections: [
        { id: "accueil", name: "Accueil" },
        { id: "a_propos", name: "À propos" },
        { id: "nosobjectifs", name: "Objectifs" },
        { id: "actualitees", name: "Actualités" },
        { id: "nousrejoindre", name: "Contact" },
        { id: "actualites", name: "ACTUALITES", url: "actualites" },
      ],
    };
  },
  mounted() {
    // Mobile menu toggle
    const mobileMenuBtn = document.getElementById("mobile-menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    mobileMenuBtn.addEventListener("click", () => {
      mobileMenu.classList.toggle("hidden");
    });

    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        if (target) {
          const offsetTop = target.offsetTop - 80; // Account for fixed header
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
          // Close mobile menu if open
          mobileMenu.classList.add("hidden");
        }
      });
    });

    // Active navigation highlighting
    window.addEventListener("scroll", () => {
      const sections = document.querySelectorAll("section[id]");
      const navLinks = document.querySelectorAll(".nav-link");

      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100;
        const sectionHeight = section.clientHeight;
        if (
          window.scrollY >= sectionTop &&
          window.scrollY < sectionTop + sectionHeight
        ) {
          current = section.getAttribute("id");

          this.activeSection = current;
        }
      });

      navLinks.forEach((link) => {
        link.classList.remove("text-indigo-600", "font-semibold");
        link.classList.add("text-gray-700");
        if (link.getAttribute("href") === `#${current}`) {
          link.classList.remove("text-gray-700");
          link.classList.add("text-indigo-600", "font-semibold");
        }
      });
    });

    // Add some interactive animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
        }
      });
    }, observerOptions);

    // Observe cards for animation
    document.querySelectorAll(".card-hover").forEach((card) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(20px)";
      card.style.transition = "opacity 0.6s ease, transform 0.6s ease";
      observer.observe(card);
    });

    const pathname = window.location.pathname.replace("/", "").split("/")[0];

    this.activeSection =
      pathname || window.location.hash.substring(1) || "home";

    window.addEventListener("scroll", this.updateActiveSection);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.updateActiveSection);
  },
  methods: {
    updateActiveSection() {
      const sections = this.sections;
      let found = false;

      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const element = document.getElementById(section.id);

        if (element) {
          const rect = element.getBoundingClientRect();

          if (rect.top >= 0 && rect.top < window.innerHeight) {
            this.activeSection = section.id;
            found = true;
            break;
          }
        }
      }

      if (!found) {
        this.activeSection = null;
      }
    },
    scrollToSection(id) {
      const element = document.getElementById(id);

      if (element) {
        const headerHeight = document.querySelector(".top-header").offsetHeight;
        const offset = 400;

        const top = element.offsetTop - headerHeight - offset;

        window.scrollTo({
          top: top,
          behavior: "smooth",
        });

        window.history.pushState(null, null, `/#${id}`);

        this.activeSection = id;
      }
    },

    openAdhesion() {
      const adhesion = document.getElementById("adhesion");

      if (adhesion) {
        adhesion.style.display = "block";
      }
    },
  },
};
</script>

<style scoped></style>
